module.exports = __webpack_public_path__ + "images/f41830df567e85a5e26870170ab85ebc.png";